import { TypeCampaignEnum } from '@/types';
import type { FlowOperatorMetadata, ValidationResult } from '@/types/flow-types';
import { canDeleteTrigger } from '@/components/flows/operators/registry';

export interface StatusCommandData {
  event: string;
}

export function createDefaultData(): StatusCommandData {
  return {
    event: 'upsert_order',
  };
}

const StatusCommand: FlowOperatorMetadata<StatusCommandData> = {
  id: 'boxstatuscommand',
  kind: 'trigger',
  label: 'flows.operators.statusCommand.label',
  icon: 'fa-bags-shopping',
  hasConfiguration: false,
  availableIn: [],
  hidden: true,

  incompatibilities: {
    [TypeCampaignEnum.AUTOMATION]: {
      nextOperators: [
        'boxabandonpanier', 'boxsitepasstime', 'boxquitsite',
        'boxperiodiclaunching', 'boxscrollpage', 'boxstatuscommand',
        'boxcustomjs', 'boxregisteronsite', 'boxsubscribetonewsletter',
        'boxdisplayfreepopup', 'boxdisplayfreemodel', 'boxfiltre_1',
        'openemail', 'clicklink', 'boxvisitpage',
        'boxdelaismax', 'boxtriggerinternalevent',
      ],
    },
  },

  defaultData: createDefaultData,

  outputs: () => 1,

  canBeDeleted(operatorId: string, flow: any): Promise<boolean | string> {
    return canDeleteTrigger(flow, operatorId);
  },
};

export default StatusCommand;
